<template>
  <div class="partner-home">
    <div class="app-loader" v-if="businessFetchWaiting">
      <span class="app-loader__message">Loading business...</span>
      <v-progress-circular
        class="mx-auto"
        :size="70"
        :width="7"
        indeterminate
      ></v-progress-circular>
    </div>
    <div class="partner-home__container" v-else-if="business">
      <v-row>
        <v-col col="3">
          <v-btn text @click="goBack">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col col="9">
          <div class="actions">
            <v-btn @click="reloadBusinessDetails()" color="primary" dark>
              <v-icon>mdi-reload</v-icon>
            </v-btn>
            <make-premium-dialog
              v-if="
                isWhitelabel &&
                account.canMakePremium
              "
              :business="business"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" v-on="on">
                  <v-icon>mdi-rocket</v-icon>
                  Make Premium
                </v-btn>
              </template>
            </make-premium-dialog>
            <make-premium-reseller-dialog
              v-if="!isWhitelabel && isEligibleToPremium"
              :business="business"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" v-on="on">
                  <v-icon>mdi-rocket</v-icon>
                  Make Premium
                </v-btn>
              </template>
            </make-premium-reseller-dialog>
            <free-trial-extend-dialog :business="business" :isWhitelabelAccount="isWhitelabel" v-if="business">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" v-on="on">
                  <v-icon>mdi-block</v-icon>
                  Add Free Trial
                </v-btn>
              </template>
            </free-trial-extend-dialog>
            <block-business-dialog
              :business="business"
              :currentState="business.isBlocked ? 'blocked' : 'unblocked'"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="!business.isBlocked" dark v-bind="attrs" v-on="on" v-show="isWhitelabel">
                  <v-icon>mdi-block</v-icon>
                  Block
                </v-btn>
                <v-btn v-if="business.isBlocked" dark v-bind="attrs" v-on="on" v-show="isWhitelabel">
                  <v-icon>mdi-block</v-icon>
                  Unblock
                </v-btn>
              </template>
            </block-business-dialog>
            <v-btn
              v-if="isWhitelabel"
              @click="reportBusiness"
              color="error"
              dark
            >
              Report
            </v-btn>
            <v-btn
              color="default"
              @click="createPremiumLink"
              v-if="!isWhitelabel && !business.activePlanId && false"
            >
              Create Payment Link
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col col="12">
          <v-card v-if="business" title="View Business">
            <v-card-title>Business Details</v-card-title>
            <v-list class="transparent">
              <v-list-item>
                <v-list-item-title> Business Id </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  {{ business.id }}
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title> Name </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  {{ business.name }}
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-title> Email </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  {{ business.email }}
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-title> Phone </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  {{ business.phone }}
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-title> Address </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  {{ business.address }}
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-title> Current Plan </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  <div>{{ business.activeProductId || "" }}</div>
                  <div>{{ business.activePlanId || "None" }}</div>

                  <div class="text-small" v-if="business.activePlanExpiry">
                    expires:
                    {{ getFormattedDate(business.activePlanExpiry) }}
                  </div>
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-title> Country </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  {{ business.country }}
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-title> Business Created </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  <div>{{ getFormattedDate(business.createdDate) }}</div>
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-title> Business Last Seen </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  <div>{{ getFormattedDate(business.lastSeenDate) }}</div>
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-title> Staff count </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  <div>{{ business.staffCount }}</div>
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-title> Customer count </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  <div>{{ business.customerCount }}</div>
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-title> Total Value </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  <div v-if="business.totalAmount">
                    {{ business.currencyCode }} {{ business.totalAmount }}
                  </div>
                  <div v-else>{{ business.currencyCode }} 0</div>
                </v-list-item-subtitle>
              </v-list-item>


              <v-list-item>
                <v-list-item-title> Notes </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  <div>{{ business.subscription && business.subscription.notes }}</div>
                </v-list-item-subtitle>
              </v-list-item>

              <div v-if="premiumLink">
                <v-list-item-title> Subscribe Link </v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  <div style="overflow: scroll; padding: 10px">
                    {{ premiumLink }}
                  </div>
                </v-list-item-subtitle>
              </div>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import MakePremiumDialog from "../../components/MakePremiumDialog.vue";
import MakePremiumResellerDialog from "../../components/MakePremiumResellerDialog.vue";
import BlockBusinessDialog from "../../components/BlockBusinessDialog.vue";
import partnerBusinessService from "../../services/partner/reseller/business";
import FreeTrialExtendDialog from "../../components/FreeTrialExtendDialog.vue";

function copyToClipboard(text) {
  var dummy = document.createElement("textarea");
  // to avoid breaking orgain page when copying more words
  // cant copy when adding below this code
  // dummy.style.display = 'none'
  document.body.appendChild(dummy);
  //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
  dummy.value = text;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
}

export default {
  components: {
    MakePremiumDialog,
    MakePremiumResellerDialog,
    BlockBusinessDialog,
    FreeTrialExtendDialog
  },
  data() {
    return {
      premiumLink: "",
    };
  },
  computed: {
    ...mapGetters({
      businessFetchWaiting: "business/businessFetchWaiting",
      businessFetchError: "business/businessFetchError",
      businessList: "business/businessList",
      account: "partner/active",
    }),
    currentBusinessId() {
      return this.$route.params.bId || null;
    },
    business() {
      return this.businessList.find((x) => x.id === this.currentBusinessId);
    },
    isWhitelabel() {
      return this.account.type == "whitelabel";
    },
    isEligibleToPremium() {
      return !this.business.activePlanExpiry || this.business.activePlanExpiry < Date.now();
    }
  },
  methods: {
    ...mapActions({
      fetchBusinesses: "business/fetchBusinesses",
    }),
    getFormattedDate(date) {
      return date ? moment(date).format("ll") : "-";
    },
    reloadBusinessDetails() {
      this.fetchBusinesses({
        activeAccount: this.account,
        bid: null,
        options: null,
      });
    },
    makePremiumDialog() {},
    async createPremiumLink() {
      const link = await partnerBusinessService.getPremiumLinkForBusiness(
        this.account.id,
        this.business
      );
      this.premiumLink = link;

      copyToClipboard(link);

      this.$notifier.showMessage({ content: "Link copied", color: "success" });
    },
    reportBusiness() {
      if (window.HelpCrunch) {
        // window.HelpCrunch("updateUserData", {
        //   currentPage: "Report Business",
        //   businessIdToReport: this.business.id,
        //   businessName: this.business.name,
        //   businessPlan: this.business.activePlanId,
        //   activeProductId: this.business.activeProductId,
        //   businessCreatedAt: this.getFormattedDate(this.business.createdDate),
        // });
        window.HelpCrunch("openChat");
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.home {
  min-height: 100%;
}

.centered-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.actions {
  display: flex;
  justify-content: flex-end;

  button {
    margin-left: 0.33rem;
  }
}
</style>
